import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BeforePrintDialogStore } from './before-print-dialog.store';
import { FilterBuilder } from '../../../helper/filter.builder';
import { ServicePatternType } from '@libs/types/src/services/enum/service-pattern-type.enum';
import { BaseDialogComponent } from '../../../../../components/kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../../../components/kit/action-buttons/action-buttons.component';
import { CheckInputComponent } from '../../../../../components/kit/input/check-input/check-input.component';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';

export interface BeforePrintDialogResponse {
    archive: boolean;
    headerId: number | null;
    footerId: number | null;
    serviceId: number;
}

/**
 * @Deprecated(BasePrintDialogComponent)
 */
@Component({
    selector: 'app-before-print-dialog',
    templateUrl: './before-print-dialog.component.html',
    styleUrl: './before-print-dialog.component.scss',
    providers: [BeforePrintDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ActionButtonsComponent,
        AsyncPipe,
        CheckInputComponent,
        ReactiveFormsModule,
        SelectInputComponent,
    ],
})
export class BeforePrintDialogComponent extends BaseDialogComponent {
    private readonly fb = inject(FormBuilder);
    protected readonly store = inject(BeforePrintDialogStore);

    form = this.fb.group({
        archive: this.fb.control<boolean>(this.dialogConfig.data?.archive ?? false),
        headerId: this.fb.control<number | null>(null),
        footerId: this.fb.control<number | null>(null),
    });
    serviceId = 0;

    constructor() {
        super();
        this.subs.push(
            this.store.serviceId$.subscribe((serviceId) => {
                if (serviceId) {
                    this.store.api.getServicePatterns(FilterBuilder.singlePage({
                        serviceId: serviceId,
                        type: ServicePatternType.DOCUMENT,
                    }));
                    this.serviceId = serviceId;
                }
            }),
        );
    }

    override save(): void {
        const data = {
            ...this.form.value,
            serviceId: this.serviceId,
        } as BeforePrintDialogResponse;
        this.dialogRef.close(data);
    }
}
